export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=5"},{"charset":"utf-8"},{"name":"theme-color","content":"#282B34"}],"link":[{"rel":"preload","href":"/fonts/HelveticaNeueCyr/HelveticaNeueCyr-Bold.woff2","as":"font","type":"font/woff2","crossorigin":"anonymous"},{"rel":"preload","href":"/fonts/HelveticaNeueCyr/HelveticaNeueCyr-Regular.woff2","as":"font","type":"font/woff2","crossorigin":"anonymous"},{"rel":"preload","href":"/fonts/HelveticaNeueCyr/HelveticaNeueCyr-Medium.woff2","as":"font","type":"font/woff2","crossorigin":"anonymous"},{"rel":"preload","href":"/fonts/HelveticaNeueCyr/HelveticaNeueCyr-Heavy.woff2","as":"font","type":"font/woff2","crossorigin":"anonymous"}],"style":[],"script":[],"noscript":[],"htmlAttrs":{"lang":"uk"},"charset":"utf-8","viewport":"width=device-width, initial-scale=1, maximum-scale=5"}

export const appPageTransition = {"name":"fade","mode":"out-in"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true